<template>
  <div class="imgBox min-w-1400">

    <div class="imgBox1 min-w-1400" id="about">
      <div class="img1Box max-w-1400">
      <el-carousel height="791px" autoplay >
        <el-carousel-item v-for="imgUrl in topSwiperImgs" :key="imgUrl">
          <img :src="imgUrl" alt="" />
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
    <div class="partnerContent min-w-1400">
      <div class="partnerBox max-w-1400">
        <img :src="partnerImg" alt="" class="partnerImg" />
      </div>
    </div>
    <div class="imgBox2 min-w-1400" ref="number" @click="change">
      <div class="img2Box max-w-1400">
        <div class="title">พลังของ MAX ASSET MANAGEMENT COMPANY LIMITED<br>สร้างการเข้าถึงบริการทางการเงิน</div>
        <div class="numberCard">
          <div class="numberCardItem" v-for="item in numberContent" :key="item.topText">
            <div class="topText">{{ item.topText }}</div>
            <div class="number" v-if="isInViewport"><CountTo ref="refcountofore" :start-val="0" :end-val="item.number" :duration="3000"></CountTo></div>
            <div class="bottomText">{{ item.bottomText }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="imgBox3 min-w-1400" id="mission">
      <div class="img3Box max-w-1400">
        <img :src="importedImg3" alt="" class="imgItem3" />
      </div>
    </div>
    <div class="imgBox4 min-w-1400" id="service">
      <div class="img4Box max-w-1400">
        <img :src="importedImg4" alt="" class="imgItem4" />
      </div>
    </div>
    <div class="imgBox5 min-w-1400">
      <div class="img5Box max-w-1400">
        <img :src="importedImg5" alt="" class="imgItem5" />
      </div>
    </div>
    <div class="imgBox5_insert min-w-1400" id="detail">
      <div class="img5Box_insert max-w-1400">
        <img :src="importedImg5_insert" alt="" class="imgItem5" />
      </div>
    </div>
    <div class="imgBox6 min-w-1400">
      <div class="img6Box max-w-1400">
        <img :src="importedImg6" alt="" class="imgItem6" />
      </div>
    </div>
    <div class="imgBox7 min-w-1400">
      <div class="img7Box max-w-1400">
        <img :src="importedImg7" alt="" class="imgItem7" />
      </div>
    </div>
    <div class="imgBox8 min-w-1400">
      <div class="img8Box max-w-1400">
        <img :src="importedImg8" alt="" class="imgItem8" />
      </div>
    </div>
    <div class="contactContent min-w-1400" id="contact">
      <div class="contactBox max-w-1400">
        <div class="title">ช่องทางการติดต่อ</div>
        <div class="contactBlock">
          <img :src="formImg" class="fromImg"/>
          <div class="formBlock">
            <div class="formTitle">
              หมายเหตุ:กรุณากรอกข้อมูลในช่องที่มีเครื่องหมาย* 
            </div>
            <div class="flex">
              <div class="formGroup">
                <div class="inputTitle">
                  ชื่อ:*
                </div>
                <input class="input" v-model="inputObject.name1" />
              </div>
              <div class="formGroup"  style="margin-right: 0px;">
                <div class="inputTitle">
                  นามสกุล:*
                </div>
                <input class="input" v-model="inputObject.name2" />
              </div>
            </div>
            <div class="formGroup">
              <div class="inputTitle">
                โทรศัพท์มือถือ:*
              </div>
              <input class="input" v-model="inputObject.phone" />
            </div>
            <div class="formGroup">
              <div class="inputTitle">
                อีเมล:*
              </div>
              <input class="input" v-model="inputObject.email" />
            </div>
            <div class="formGroup">
              <div class="inputTitle">
                เรื่อง:*
              </div>
              <input class="input" v-model="inputObject.story" />
            </div>
            <div class="formGroup">
              <div class="inputTitle">
                ข้อความ:*
              </div>
              <input class="input" v-model.trim="inputObject.notice" />
            </div>
            <div class="flex-center">
            <button @click="subForm" class="subButton">ส่งข้อความ</button></div>
          </div>
        </div>
      </div>
    </div>
    <div class="mapBox min-w-1400" id="detail">
      <div class="imgMapBox max-w-1400">
        <img :src="mapImg" alt="" class="mapImg" />
      </div>
    </div>
    <div class="imgAniContent min-w-1400" id="comment">
      <div class="imgAniBox max-w-1400">
        <div class="title">ขั้นตอนการกู้ยืม</div>
        <div class="imgAni">
        <img :src="imgWrapper" alt="" class="imgWrapper" />
        <img :src="imgWrapper" alt="" class="imgWrapper" />
        </div>
      </div>
    </div>
    <div class="imgBox9 min-w-1400">
      <div class="img9Box max-w-1400">
        <img :src="importedImg9" alt="" class="imgItem9" />
      </div>
    </div>
    <div class="imgBox10 min-w-1400">
      <div class="img10Box max-w-1400">
        <img :src="importedImg10" alt="" class="imgItem10" />
      </div>
    </div>
  </div>
</template>

<script>
import "./index.css";
// import importedImg1 from "@/page/maxassetcompany/components/img/1_1.png";
import importedImg2 from "@/page/maxassetcompany/components/img/1_2.png";
import importedImg3 from "@/page/maxassetcompany/components/img/1_3.png";
import importedImg4 from "@/page/maxassetcompany/components/img/1_4.png";
import importedImg5 from "@/page/maxassetcompany/components/img/1_5.png";
import importedImg6 from "@/page/maxassetcompany/components/img/1_6.png";
import importedImg7 from "@/page/maxassetcompany/components/img/1_7.png";
import importedImg8 from "@/page/maxassetcompany/components/img/1_8.png";
import importedImg9 from "@/page/maxassetcompany/components/img/1_9.png";
import importedImg10 from "@/page/maxassetcompany/components/img/1_10.png";

import mapImg from "@/page/maxassetcompany/components/img/map.png";
import swiper1 from "@/page/maxassetcompany/components/img/swiper_1.png";
import swiper2 from "@/page/maxassetcompany/components/img/swiper_2.png";
import swiper3 from "@/page/maxassetcompany/components/img/swiper_3.png";
import formImg from "@/page/maxassetcompany/components/img/form_left.png";
import formPlace from "@/page/maxassetcompany/components/img/form_place.png";
import partnerImg from "@/page/maxassetcompany/components/img/partner.png";
import imgWrapper from "@/page/maxassetcompany/components/img/imgWrapper.png";
import importedImg5_insert from "@/page/maxassetcompany/components/img/1_5_insert.png";

import CountTo from 'vue-count-to'

export default {
  components: {
    CountTo
  },
  data() {
    return {
      topSwiperImgs: [swiper1, swiper2, swiper3],
      numberContent:[
        {
          topText: "ช่วยเหลือลูกค้า",
          number: 1436462,
          bottomText: "กรณี",
        },
        {
          topText: "ยืมมา",
          number: 3000000,
          bottomText: "สินเชื่อเงินบาท",
        },
        {
          topText: "จัดอบรมความรู้ทางการเงิน",
          number: 1368,
          bottomText: "สาขา",
        },
      ],
      // importedImg1: importedImg1,
      importedImg2: importedImg2,
      importedImg3: importedImg3,
      importedImg4: importedImg4,
      importedImg5: importedImg5,
      importedImg6: importedImg6,
      importedImg7: importedImg7,
      importedImg8: importedImg8,
      importedImg9: importedImg9,
      importedImg10: importedImg10,
      mapImg:mapImg,
      partnerImg: partnerImg,
      imgWrapper:imgWrapper,
      importedImg5_insert:importedImg5_insert,
      altText: "图片",
      formPlace:formPlace,
      formImg:formImg,
      inputObject: {
        name1: "",
        name2: "",
        phone: "",
        email: "",
        story:"",
        notice:""
      },
      isInViewport: false,
      observer: null
    };
  },
  created() {
    // this.gotoTop();
  },
  mounted() {
    this.observer = new IntersectionObserver((entries) => {
      // if(!entries[0].isIntersecting) return;
      this.isInViewport = entries[0].isIntersecting
      console.log("change", this.isInViewport);
    }, {
      threshold: 0.1
    })
    this.observer.observe(this.$refs.number);
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect()
    }
  },
  methods: {
    gotoTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    change(){
      this.isInViewport=true;
      console.log("change", this.isInViewport);
    },
    subForm(){
      if (Object.values(this.inputObject).some(value => value === "")) {
        this.$message({
          message: 'กรุณากรอกเนื้อหาของคุณ!',
          type: 'error'
        });
      }else{
        setTimeout(()=>{
          this.$message({
          message: 'การส่งสําเร็จ',
          type: 'success'
        });
          this.clearForm();
        },1000)
      }
    },
    clearForm(){
      for (const key in this.inputObject) {
        this.inputObject[key] = "";
      }
    }
  },
};
</script>

<style scoped>
  
#about,#mission,#detail,#comment,#contact {
  scroll-margin-top: 180px;
   /* 
   fix:Zeekin
   由于导航栏固定导致滚动后会有部分遮挡，通过该方法设置偏移
    */
}
.imgBox {
  display: flex;
  flex-direction: column;
  background-color: white;
}

img {
  display: block;
}

.swiperBox{
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.test{
  width: 1300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.imgBox1,
.imgBox2,
.imgBox3,
.imgBox4,
.imgBox5,
.imgBox5_insert,
.imgBox6,
.imgBox7,
.imgBox8,
.imgBox9,
.imgBox10,
.contactContent,
.partnerContent,
.imgAniContent,
.mapBox {
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: "";
}

.partnerContent {
  margin: 95px 0 116px 0;
}

.img1Box,
.img2Box,
.img3Box,
.img4Box,
.img5Box,
.img5Box_insert,
.img6Box,
.img7Box,
.img8Box,
.img9Box,
.img10Box,
.partnerBox,
.contactBox,
.imgAniBox,
.imgMapBox {
  margin: 0;
  overflow: hidden;
  width: 100%;
  background-color: "";
}

.imgItem1,
.imgItem2,
.imgItem3,
.imgItem4,
.imgItem5,
.imgItem6,
.imgItem7,
.imgItem8,
.imgItem9,
.imgItem10,
.partnerImg,
.mapImg{
  width: 100%;
  margin: 0;
}

.mapImg{
  margin-bottom: 100px;
}

.imgAni{
  display: flex;
  height: 300px;
  transform: scale(1.5);
  animation: ani 35s linear infinite;
}

@keyframes ani {
  0% {
    translate: 0px 0;
  }
  100% {
    translate: -2450px 0;
  }

}

.imgWrapper{
  width: 100%;
  object-fit: contain;
  margin: 0;
  margin-right: 15px;
}

.img2Box,.img3Box,.imgBox5,.img10Box{
  padding: 0 220px;
  margin-bottom: 110px;
}

.img4Box,.img5Box_insert,.imgAniBox{
  margin-bottom: 90px;
}

.img6Box,.img7Box,.img8Box,.img9Box{
  padding: 0 220px;
  margin-bottom: 90px;
}

.title{
 color: #000000;
 text-align: center;
 font-family: "Thonburi";
 font-size: 34px;
 font-style: normal;
 font-weight: 700;
 line-height: normal;
 margin-bottom: 65px;
}

.numberCard{
  display: flex;
  gap: 20px;
  justify-content:space-between;
  margin-bottom: 10px;
}

.numberCardItem{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 370px;
  height: 192px;
  flex-shrink: 0;
  border-radius: 12px;
  background: #FFF;
  box-shadow: 0 4px 16.7px 0 #25496a26;
}

.topText{
  color: #333333;
  text-align: center;
  font-family: "Thonburi";
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal; 
}

.number{
  color: #ff5e26;
  text-align: center;
  font-family: "Thonburi";
  font-size: 40px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.bottomText{
  color: #666666;
  text-align: center;
  font-family: "Thonburi";
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: normal; 
}

.contactBlock{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.fromImg{
  width: 48%;
}

.contactBox{
  padding: 0 220px;
  margin-bottom: 70px;
}

.formBlock{
  height: 710px;
  padding: 20px;
  width: 48%;
  flex-shrink: 0;
  border-radius: 10px;
  border: 3px solid #0841a60d;
}

.formTitle{
 color: #ff5e26;
 font-family: "Thonburi";
 font-size: 20px;
 font-style: normal;
 font-weight: 400;
 line-height: normal;
}

.inputTitle {
 color: #333333;
 font-family: "Thonburi";
 font-size: 24px;
 font-style: normal;
 font-weight: 700;
 line-height: normal;
 margin-bottom: 15px;
}

.formGroup{
  width: 100%;
  margin-top: 20px;
  margin-right: 20px;
}

.input {
  width: 100%;
  padding: 0 20px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 26.5px;
  border: 1.5px solid #D8E5EC;
}

.flex {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.flex-center {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.subButton{
  margin-top: 20px;
  width: 150px;
height: 50px;
font-size: 16px;
flex-shrink: 0;
border-radius: 10px;
background: #FF5E26;
color: white;
}

</style>
